import apiClient from './client';

export const listAuditLogs = (params) => apiClient.get('/audit-logs', { params }).then((r) => r.data);
export const auditLogExportUrl = (params = {}) => {
  const query = new URLSearchParams(params).toString();
  return `${apiClient.defaults.baseURL}/audit-logs/export${query ? `?${query}` : ''}`;
};
